export default __webpack_public_path__ + "fonts/tpl_5.ad4bc9807c98877a1337c8fc6ff28b4d.png";